import { documentsRegister } from "../api/documentsRegister";

export const getDocumentsRegister = () => {
  return documentsRegister.getDocumentsRegister().then(response => response);
};
